import clsx from "clsx"
import { FC, memo } from "react"
import { Trans, useTranslation } from "react-i18next"
import { ICardDiscardedLog } from "@/store/apis/gameplayAPI"
import styles from "./LogCardDiscarded.module.scss"

const LogCardDiscardedComponent: FC<ICardDiscardedLog> = (props) => {
  const { t } = useTranslation("cards")

  return (
    <span className={clsx(styles.LogEffectApplied)}>
      <Trans
        i18nKey="logs.cardDiscarded"
        components={{ span: <span className="blue" /> }}
        values={{ cardType: t(`card.${props.details.type}.title.accusative`) }}
      />
    </span>
  )
}

export const LogCardDiscarded = memo(LogCardDiscardedComponent)
